const Qs = require('qs')

export const querySerializer = {
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: 'comma' })
  },
}
